import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { DiagnosticsAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-diagnostics-slot',
    templateUrl: './diagnostics-slot.component.html',
    styleUrl: './diagnostics-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DiagnosticsSlotComponent implements SheetSlotComponentBase {

	@Input() action!: DiagnosticsAction;
	value = null;

	constructor() {
	}
}